import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { setupVueErrorHandling, setupPageTracking } from './appinsights-vue'
import Vue from 'vue'

export default function (ctx, inject) {
  const config = {"instrumentationKey":"4bd2feea-dc56-4af6-944f-e642b75c85e8"}
  // runtimeConfig
  const runtimeConfig = ctx.$config && ctx.$config.appInsights || {}

  const appInsights = new ApplicationInsights({
     config: {...config, ...runtimeConfig}
  })

  inject('appInsights', appInsights)

  // Initialize appInsights

  // Initialize appInsights

  appInsights.loadAppInsights()
  setupVueErrorHandling(Vue, appInsights)

  setupPageTracking(ctx.app.router, appInsights)
}
